import React from 'react';
import '../styles/PaymentInfoCards.css';

const PaymentInfoCards = () => {
  return (
    <div className="payment-info-container">
      <h3 className="payment-cards-title">Elige cualquiera de estas 2 formas de pago. Recuerda que tienes hasta 5 días después de tu fecha de vencimiento para mantener esta subscripción</h3>
      
      <div className="payment-cards-container">
        {/* Tarjeta Banregio */}
        <div className="payment-card">
          <h4>Banco Banregio</h4>
          <div className="payment-details">
            <p><strong>No. de Cuenta:</strong> 271984990018</p>
            <p><strong>CLABE:</strong> 058650000003944002</p>
          </div>
        </div>

        {/* Tarjeta OXXO */}
        <div className="payment-card">
          <h4>Depósito OXXO</h4>
          <div className="payment-details">
            <p><strong>Código:</strong> 2242 1706 5056 3188</p>
            <p><strong>CLABE:</strong> 728969000142559007</p>
          </div>
        </div>
      </div>

      <div className="payment-note">
        <p className="note-line"><strong>Nota:</strong> Una vez realizado el pago, envía copia del comprobante de pago a <a href="mailto:ventaz@nobordertech.com">ventaz@nobordertech.com</a>,</p>
        <p className="note-line">incluye tu email registrado y el nombre de tu negocio.</p>
      </div>
    </div>
  );
};

export default PaymentInfoCards;
